import { chains } from '../constants/chains';

export function getChainInfo(symbol) {
  return chains.find((x) => x.id === symbol);
}

